// jsaForm/v1/confinedSpace.actions.js

// Helper to get all entry data fields reset to default values
const getResetEntryDataFields = () => ({
  cseBreakingPlaneYes: false,
  cseBreakingPlaneNo: false,
  csePermitEwi: false,
  csePermitClient: false,
  csePermitClientApproved: false,
  csePermitClientNotApproved: false,
  cseAdminNotifiedYes: false,
  cseAdminNotifiedNo: false,
  cseAdminNotificationTime: "",
  cseAdminNotificationDate: "",
  cseAdminName: "",
});

// Helper to get breaking plane data fields reset to default values
const getResetBreakingPlaneDataFields = () => ({
  cseBreakingPlaneYes: false,
  csePermitEwi: false,
  csePermitClient: false,
  csePermitClientApproved: false,
  csePermitClientNotApproved: false,
  cseAdminNotifiedYes: false,
  cseAdminNotifiedNo: false,
  cseAdminNotificationTime: "",
  cseAdminNotificationDate: "",
  cseAdminName: "",
});

export const makeJsaV1CsActions = ({ setJsaUi, bump, emitJsaPatch }) => ({
  updateCseEntryYes(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCseEntryYes(value);
    const entryYesFields = { cseEntryYes: value };
    if (!value) {
      Object.assign(entryYesFields, getResetEntryDataFields());
    } else {
      entryYesFields.cseEntryNo = false;
    }
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        entryYesFields,
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    setJsaUi({
      v1: (prev) => ({
        ...prev,
        confinedSpace: {
          ...(prev?.confinedSpace || {}),
          showCseEntrySection: value,
        },
      }),
    });
    bump();
  },

  updateCseEntryNo(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCseEntryNo(value);
    const entryNoFields = { cseEntryNo: value };
    if (value) {
      entryNoFields.cseEntryYes = false;
      Object.assign(entryNoFields, getResetEntryDataFields());
    }
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        entryNoFields,
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    if (value) {
      setJsaUi({
        v1: (prev) => ({
          ...prev,
          confinedSpace: {
            ...(prev?.confinedSpace || {}),
            showCseEntrySection: false,
          },
        }),
      });
    } else {
      bump();
    }
  },

  updateCsePermitEwi(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCsePermitEwi(value);
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        { csePermitEwi: value },
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateCsePermitClient(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCsePermitClient(value);
    const permitClientFields = { csePermitClient: value };
    if (!value) {
      permitClientFields.csePermitClientApproved = false;
      permitClientFields.csePermitClientNotApproved = false;
    }
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        permitClientFields,
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    setJsaUi({
      v1: (prev) => ({
        ...prev,
        confinedSpace: {
          ...(prev?.confinedSpace || {}),
          showCsePermitClientSection: value,
        },
      }),
    });
    bump();
  },

  updateCsePermitClientApproved(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCsePermitClientApproved(value);
    const approvedFields = { csePermitClientApproved: value };
    if (value) {
      approvedFields.csePermitClientNotApproved = false;
    }
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        approvedFields,
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateCsePermitClientNotApproved(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCsePermitClientNotApproved(value);
    const notApprovedFields = { csePermitClientNotApproved: value };
    if (value) {
      notApprovedFields.csePermitClientApproved = false;
    }
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        notApprovedFields,
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateCseAdminNotifiedYes(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCseAdminNotifiedYes(value);
    const adminYesFields = { cseAdminNotifiedYes: value };
    if (value) {
      adminYesFields.cseAdminNotifiedNo = false;
    } else {
      adminYesFields.cseAdminNotificationTime = "";
      adminYesFields.cseAdminNotificationDate = "";
      adminYesFields.cseAdminName = "";
    }
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        adminYesFields,
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    setJsaUi({
      v1: (prev) => ({
        ...prev,
        confinedSpace: {
          ...(prev?.confinedSpace || {}),
          showAdminNotifiedSection: value,
        },
      }),
    });
    bump();
  },

  updateCseAdminNotifiedNo(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCseAdminNotifiedNo(value);
    const adminNoFields = { cseAdminNotifiedNo: value };
    if (value) {
      adminNoFields.cseAdminNotifiedYes = false;
      adminNoFields.cseAdminNotificationTime = "";
      adminNoFields.cseAdminNotificationDate = "";
      adminNoFields.cseAdminName = "";
    }
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        adminNoFields,
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    if (value) {
      setJsaUi({
        v1: (prev) => ({
          ...prev,
          confinedSpace: {
            ...(prev?.confinedSpace || {}),
            showAdminNotifiedSection: false,
          },
        }),
      });
    } else {
      bump();
    }
  },

  updateCseAdminNotificationTime(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCseAdminNotificationTime(value);
    if (emitPatch) {
      // Use the formatted time from the model, not the raw value
      const formattedTime = jsaData.jsaConfinedSpace.cseAdminNotificationTime;
      const patch = jsaData.jsaConfinedSpace.toPatch(
        { cseAdminNotificationTime: formattedTime },
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateCseAdminNotificationDate(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCseAdminNotificationDate(value);
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        {
          cseAdminNotificationDate:
            jsaData.jsaConfinedSpace.cseAdminNotificationDate,
        },
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateCseAdminName(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCseAdminName(value);
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        { cseAdminName: value },
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },

  updateCseBreakingPlaneYes(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCseBreakingPlaneYes(value);
    const breakingYesFields = { cseBreakingPlaneYes: value };
    if (!value) {
      Object.assign(breakingYesFields, getResetBreakingPlaneDataFields());
    } else {
      breakingYesFields.cseBreakingPlaneNo = false;
    }
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        breakingYesFields,
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    setJsaUi({
      v1: (prev) => ({
        ...prev,
        confinedSpace: {
          ...(prev?.confinedSpace || {}),
          showCseBreakingPlaneSection: value,
          ...(value ? {} : { showCsePermitClientSection: false }),
        },
      }),
    });
    bump();
  },

  updateCseBreakingPlaneNo(jsaData, value, emitPatch) {
    jsaData.jsaConfinedSpace.updateCseBreakingPlaneNo(value);
    const breakingNoFields = { cseBreakingPlaneNo: value };
    if (value) {
      Object.assign(breakingNoFields, getResetBreakingPlaneDataFields());
    }
    if (emitPatch) {
      const patch = jsaData.jsaConfinedSpace.toPatch(
        breakingNoFields,
        jsaData.jsaBasicInfo.rowId
      );
      emitJsaPatch(patch, emitPatch);
    }
    if (value) {
      setJsaUi({
        v1: (prev) => ({
          ...prev,
          confinedSpace: {
            ...(prev?.confinedSpace || {}),
            showCseBreakingPlaneSection: false,
            showCsePermitClientSection: false,
          },
        }),
      });
    } else {
      bump();
    }
  },
});
